<div class="auth-container">
  <div class="auth-wrapper">
    <!-- Header -->
    <div class="auth-header">
      <h1 class="auth-title">Welcome</h1>
      <p class="auth-subtitle">Sign in to your account or create a new one</p>
    </div>

    <!-- Auth Cards -->
    <div class="auth-cards">

      <!-- Customer Login Card -->
      <div class="nlc-card auth-card" (click)="signInCustomer()">
        <div class="card-icon customer-icon">
          <mat-icon>person</mat-icon>
        </div>
        <h2 class="card-title">Customer Sign In</h2>
        <p class="card-description">Access your orders, coins, and account details</p>
        <button mat-flat-button class="card-button customer-button">
          Sign In
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>

      <!-- Employee Login Card -->
      <div class="auth-card" (click)="signInEmployee()">
        <div class="card-icon employee-icon">
          <mat-icon>badge</mat-icon>
        </div>
        <h2 class="card-title">Employee Sign In</h2>
        <p class="card-description">Access admin panel and management tools</p>
        <button mat-flat-button class="card-button employee-button">
          Sign In
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>

    </div>

    <!-- Footer -->
    <div class="auth-footer">
      <p>By continuing, you agree to our <a href="/impressum">Terms of Service</a></p>
    </div>
  </div>
</div>
